/**
 * 予算のテキスト表示
 * @param rfp
 */
export const getBudgetText = (rfp) => {
    const { budget, maxBudget } = rfp;
    const min = budget ? `${budget.toLocaleString()}万円` : 0;
    const max = maxBudget ? `${maxBudget.toLocaleString()}万円` : 0;
    if (!min && !max) {
        return 'OPEN';
    }
    if (min && !max) {
        return `${min}〜`;
    }
    if (!min && max) {
        return `〜${max}`;
    }
    return `${min}〜${max}`;
};
